export default __webpack_public_path__ + "static/logo-26c93dad03d138a3c5742d666340fb2f.png";